module.exports = __webpack_public_path__ + "img/icon3.ee2454ee.png";